import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *视频列表
 * @param params
 * 
*/

export const videoList = params => Http.get(`${baseUrl}/sz/team/jj/my`, { params })

/**
 *保存视频
 * @param params
 * 
*/

export const saveVideo = params => Http.post(`${baseUrl}/sz/team/jj/my`, params )

/**
 *删除视频
 * @param waId
 * 
*/

export const delVideo = waId => Http.delete(`${baseUrl}/sz/team/jj/my/${waId}`)

/**
 *团队视频列表
 * @param params
 * 
*/

export const result = params => Http.get(`${baseUrl}/sz/team/jj`, { params })
